var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component, { mixins } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
// eslint-disable-next-line import/no-extraneous-dependencies
import { BTooltip } from 'bootstrap-vue';
import EventBus from '@/mixin/eventBus';
import DatesAndTimesMixin from '@/mixin/datesAndTimes';
import { v4 as uuid } from 'uuid';
// eslint-disable-next-line no-use-before-define
let HumanizeDate = class HumanizeDate extends mixins(EventBus, DatesAndTimesMixin) {
    constructor() {
        super(...arguments);
        this.humanizedDate = this.humanizeDate(this.date, this.$i18n.locale);
        this.id = `humanize-date-${uuid()}`;
    }
    onLocaleChange() {
        this.humanizedDate = this.humanizeDate(this.date, this.$i18n.locale);
    }
};
__decorate([
    Prop({ required: true })
], HumanizeDate.prototype, "date", void 0);
__decorate([
    Watch('$i18n.locale', { immediate: true })
], HumanizeDate.prototype, "onLocaleChange", null);
HumanizeDate = __decorate([
    Component({
        components: {
            BTooltip,
        },
        mounted() {
            this.$onEvent('update-time-ago-moment-js', () => {
                this.humanizedDate = this.humanizeDate(this.date, this.$i18n.locale);
            });
        },
    })
], HumanizeDate);
export default HumanizeDate;
